export const CARD_TYPES = Object.freeze({
  VIRTUAL: 'virtual',
  PHYSICAL: 'physical',
});

export function normalizeCardType(value) {
  const normalizedType = String(value || '').trim().toLowerCase();

  if (normalizedType.includes(CARD_TYPES.PHYSICAL)) {
    return CARD_TYPES.PHYSICAL;
  }

  return CARD_TYPES.VIRTUAL;
}

export function isPhysicalCardType(value) {
  return normalizeCardType(value) === CARD_TYPES.PHYSICAL;
}
